import {
  AvailablePage,
  AvailablePageWithUniqueName,
} from '@mm/state/interfaces/connected-page';

const addIdToNonUniqueNamePages = (
  pages: AvailablePage[],
): AvailablePageWithUniqueName[] => {
  const uniqueNames: { [key: string]: number } = {};

  pages.forEach(p => {
    if (!uniqueNames[p.name]) {
      uniqueNames[p.name] = 1;
    } else {
      uniqueNames[p.name] = uniqueNames[p.name] + 1;
    }
  });

  return pages.map(p => {
    if (uniqueNames[p.name] === 1) return p;
    return { ...p, uniqueName: `${p.name} (${p.remoteId})` };
  });
};

export { addIdToNonUniqueNamePages };
